import { allListModel } from './allList.model'
import { loadingModel } from './loding.model'

export default {
  list: allListModel,
  loading: loadingModel,
}
